import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const BacklogDetailStyled = styled(Box).attrs({
  justifyContent: { sm: 'center' },
  pl: { sm: '400' },
  pr: { sm: '450' },
  pt: { sm: '500' },
})`
  width: 100%;
`;

//GDS Box Styled Component replaced with styled.div for needed Droppable ref
export const BacklogMilestoneStyled = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  ${({ theme }) => css`
    padding-left: ${theme.spacings[400]};
    padding-right: ${theme.spacings[450]};
    padding-top: ${theme.spacings[400]};
  `}
`;

export const LabelStyled = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  ${({ theme }) => css`
    padding-left: ${theme.spacings[500]};
    padding-right: ${theme.spacings[500]};
    padding-top: ${theme.spacings[500]};
    padding-bottom: ${theme.spacings[400]};
    span {
      margin-top: ${({ theme }) => theme.spacings[100]};
    }
  `}
`;
